import { ReactElement, useContext, useMemo } from 'react';

import { getAuth, Topbar } from '@beeline/lk-utils';

import styles from './styles.module.scss';

import { ShowcaseBanner } from ':components/ShowcaseBanner';
import {
  APP_LK_EMPLOYEE_HOST,
  APP_AUTH_SERVER_URL,
  APP_API_URL,
  ShowcaseContext,
  NEW_NOTIFICATIONS_WIDGET,
} from ':constants';

const env = {
  mf: APP_LK_EMPLOYEE_HOST,
  auth: APP_AUTH_SERVER_URL,
  api: APP_API_URL,
};
const authHandler = (
  onTokenReady: (
    token: string,
    tokenType: string,
    refreshToken: () => Promise<string>,
  ) => void,
  // clearAuth: () => void,
): void => {
  const auth = getAuth();
  const refreshToken = async (): Promise<string> => {
    if (auth) {
      const { access_token } = await auth.refreshTokens();
      return access_token!;
    }

    throw new Error('no auth instance');
  };

  auth?.getAccessTokenAsync().then(accessToken => {
    onTokenReady(accessToken, 'eauth', refreshToken);
  });
  // TODO: временно убрал clearAuth() т.к. нужны доработки библиотеки авторизации
  // а на витрине это всё равно нигде не используется
  // if (token) {
  //   onTokenReady(token, 'eauth', refreshToken);
  // } else {
  //   clearAuth();
  // }
};

export const Header = (): ReactElement => {
  const showcaseInfo = useContext(ShowcaseContext);

  const externalModules = useMemo(() => {
    if (!showcaseInfo?.settings.topbar.component.is_active) return undefined;
    const { component } = showcaseInfo.settings.topbar;
    return {
      main: {
        host: component.url,
        componentId: component.component_id,
      },
    };
  }, [showcaseInfo]);

  if (!showcaseInfo) return <div>Что-то пошло не так</div>;

  const {
    settings: { topbar },
    name,
    banner,
  } = showcaseInfo;

  return (
    <div className={styles.header}>
      <Topbar
        title={name}
        authHandler={authHandler}
        customEnv={env}
        externalModules={externalModules}
        isShowcaseApp
        options={{
          notifications: topbar.notifications,
          notificationsNew: NEW_NOTIFICATIONS_WIDGET,
          menu: topbar.menu,
          profile: topbar.profile,
          isShowcase: true,
        }}
      />
      {banner && <ShowcaseBanner text={banner.description} />}
    </div>
  );
};
